module.exports = __webpack_public_path__ + "img/category-7.40b0f766.svg";